export default function Marquee({ text = 'WARNING : MAY CAUSE AN IRRESISTIBLE URGE TO SNACK ALL THE TIME...', dark = false, reverse = false, speed = '38s', testid = 'marquee' }) {
  const items = Array.from({ length: 8 }, () => text);
  return (
    <div data-testid={testid} className={`py-3 overflow-hidden relative z-10 ${dark ? 'bg-cocoa text-kyellow' : 'bg-cream text-maroon border-y-2 border-cocoa/10'}`}>
      <div className={`marquee-track items-center ${reverse ? 'marquee-rev' : ''}`} style={{ '--mq-t': speed }}>
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="font-cond font-bold text-sm sm:text-base tracking-[0.12em] uppercase px-4 whitespace-nowrap">{item}</span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
